import { useEffect, useState } from 'react';
import { versionCheckService } from '../utils/versionCheckService';

/**
 * Component that shows a notification when a new version is available
 */
export function VersionUpdateNotification() {
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    // Subscribe to version updates
    const unsubscribe = versionCheckService.onVersionUpdate(() => {
      setShowNotification(true);
    });

    return unsubscribe;
  }, []);

  const handleReload = () => {
    versionCheckService.reloadForUpdate();
  };

  const handleDismiss = () => {
    setShowNotification(false);
  };

  if (!showNotification) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        backgroundColor: '#4F46E5',
        color: 'white',
        padding: '16px 20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontFamily: 'Poppins, sans-serif',
        maxWidth: '400px',
        animation: 'slideIn 0.3s ease-out'
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, marginBottom: '4px' }}>
          Update Available
        </div>
        <div style={{ fontSize: '14px', opacity: 0.9 }}>
          A new version is available. Reload to update.
        </div>
      </div>
      <button
        onClick={handleReload}
        style={{
          backgroundColor: 'white',
          color: '#4F46E5',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '6px',
          fontWeight: 600,
          cursor: 'pointer',
          fontSize: '14px',
          fontFamily: 'Poppins, sans-serif'
        }}
      >
        Reload
      </button>
      <button
        onClick={handleDismiss}
        style={{
          backgroundColor: 'transparent',
          color: 'white',
          border: 'none',
          padding: '8px',
          cursor: 'pointer',
          fontSize: '20px',
          lineHeight: 1
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}
